<template>
    <b-container fluid>
        <b-breadcrumb
            :items="breadcrumbItems"
            class="minus-gutters"
        ></b-breadcrumb>
        <!-- <b-embed
            type="iframe"
            aspect="16by9"
            :src="iframeUrl"
            allowfullscreen
        ></b-embed> -->
        <iframe class="w-100" id="u83_input" scrolling="auto" frameborder="1" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" :src="iframeUrl"></iframe>
    </b-container>
</template>
<script>
    export default {
        data() {
            return {
                breadcrumbItems: [],
                iframeUrl: "",
                iframeList: {
                    agri_1: "https://app.powerbi.com/view?r=eyJrIjoiNTk3MzUyZDAtMTdlYS00YjM0LTk2ZDMtNTVjNTdhOWJjOGI0IiwidCI6IjZiYWFiYzA4LTU0MzEtNGJhOC1iZDE5LTVhZmZmZmE0MmY2NCIsImMiOjEwfQ%3D%3D&pageName=ReportSection02be6a92f09b438b464d",
                    agri_2: "https://app.powerbi.com/view?r=eyJrIjoiMzA4YWZiYzUtMDFmYi00MGQxLWIxZmEtNDA5YzE4ZDNlNjE3IiwidCI6IjZiYWFiYzA4LTU0MzEtNGJhOC1iZDE5LTVhZmZmZmE0MmY2NCIsImMiOjEwfQ%3D%3D&amp;pageName=ReportSection",
                    agri_3: "https://app.powerbi.com/view?r=eyJrIjoiYzg1MzI3N2QtNTAwZS00OGM1LWI2OTktMjI0ZmUyM2JmY2NkIiwidCI6IjZiYWFiYzA4LTU0MzEtNGJhOC1iZDE5LTVhZmZmZmE0MmY2NCIsImMiOjEwfQ%3D%3D",
                    agri_4: "https://app.powerbi.com/view?r=eyJrIjoiZjNjMGI3NWItNDBkNC00OTg3LWFjNTItMWJmYTRmNGQyNDYxIiwidCI6IjZiYWFiYzA4LTU0MzEtNGJhOC1iZDE5LTVhZmZmZmE0MmY2NCIsImMiOjEwfQ%3D%3D",
                    agri_5: "https://app.powerbi.com/view?r=eyJrIjoiNTUyNDZhZjgtMTNhZi00NTE5LTk0OGQtNmNjN2I4YWRhOWNkIiwidCI6IjZiYWFiYzA4LTU0MzEtNGJhOC1iZDE5LTVhZmZmZmE0MmY2NCIsImMiOjEwfQ%3D%3D&pageName=ReportSection",
                    agri_6: "https://app.powerbi.com/view?r=eyJrIjoiMGViY2RiZjctOGM0Yy00ZjY5LTgxMDctNmE0NGQzYmM4OTQ5IiwidCI6IjZiYWFiYzA4LTU0MzEtNGJhOC1iZDE5LTVhZmZmZmE0MmY2NCIsImMiOjEwfQ%3D%3D&pageName=ReportSection",
                    agri_7: "https://app.powerbi.com/view?r=eyJrIjoiMmIzNWY2NWQtNTAwMC00ZjRhLTkyN2YtMzZlMDYyM2MxMTBjIiwidCI6IjZiYWFiYzA4LTU0MzEtNGJhOC1iZDE5LTVhZmZmZmE0MmY2NCIsImMiOjEwfQ%3D%3D&pageName=ReportSection19576e52ae8aaed49321",
                    fish_1: "https://app.powerbi.com/view?r=eyJrIjoiNzQ4ZDU4MTQtMGU2YS00ZTA3LThlOTctYzg0MDA2N2FmZDlhIiwidCI6IjZiYWFiYzA4LTU0MzEtNGJhOC1iZDE5LTVhZmZmZmE0MmY2NCIsImMiOjEwfQ%3D%3D&pageName=ReportSection1eaec3a4be1f15645168",
                    animal_1: "https://app.powerbi.com/view?r=eyJrIjoiY2M5M2FlNjItODI2Ni00ZDRkLTlkMjMtZTBhYjQ3OGUwMjA3IiwidCI6IjZiYWFiYzA4LTU0MzEtNGJhOC1iZDE5LTVhZmZmZmE0MmY2NCIsImMiOjEwfQ%3D%3D&pageName=ReportSection6d6bc3e49cefdcfbc868",
                },
                iframeName: {
                    agri_1: "雲林縣主要農作物產銷資訊",
                    agri_2: "各縣市種植面積比較",
                    agri_3: "農產品產銷預警分析",
                    agri_4: "價格分析",
                    agri_5: "農產品進出口資料統計",
                    agri_6: "農作物產期狀況",
                    agri_7: "水稻情形",
                    fish_1: "漁業儀表板",
                    animal_1: "畜產儀表板",
                }
            }
        },
        watch: { $route(to, from) { 
                if(to !== from){
                    location.reload();
                } 
            }
        },
        mounted(){
            this.checkPermission();
        },
        created() {
            window.addEventListener("resize", this.resizeIframe);
        },
        destroyed() {
            window.removeEventListener("resize", this.resizeIframe);
        },
        methods: {
            async checkPermission()
            {
                if(this.$route.params.id == "agri_1"){
                    let accountdata = {PJ_ID: 'PJ000000000023', fun:this.checkshowByPJID}
                    this.FunctionToken(this.Authority, accountdata)
                }
                else if(this.$route.params.id == "agri_2"){
                    let accountdata = {PJ_ID: 'PJ000000000024', fun:this.checkshowByPJID}
                    this.FunctionToken(this.Authority, accountdata)
                }
                else if(this.$route.params.id == "agri_3"){
                    let accountdata = {PJ_ID: 'PJ000000000025', fun:this.checkshowByPJID}
                    this.FunctionToken(this.Authority, accountdata)
                }
                else if(this.$route.params.id == "agri_4"){
                    let accountdata = {PJ_ID: 'PJ000000000026', fun:this.checkshowByPJID}
                    this.FunctionToken(this.Authority, accountdata)
                }
                else if(this.$route.params.id == "agri_5"){
                    let accountdata = {PJ_ID: 'PJ000000000027', fun:this.checkshowByPJID}
                    this.FunctionToken(this.Authority, accountdata)
                }
                else if(this.$route.params.id == "agri_6"){
                    let accountdata = {PJ_ID: 'PJ000000000030', fun:this.checkshowByPJID}
                    this.FunctionToken(this.Authority, accountdata)
                }
                else if(this.$route.params.id == "agri_7"){
                    let accountdata = {PJ_ID: 'PJ000000000039', fun:this.checkshowByPJID}
                    this.FunctionToken(this.Authority, accountdata)
                }
                else if(this.$route.params.id == "fish_1"){
                    let accountdata = {PJ_ID: 'PJ000000000033', fun:this.checkshowByPJID}
                    this.FunctionToken(this.Authority, accountdata)
                }
                else if(this.$route.params.id == "animal_1"){
                    let accountdata = {PJ_ID: 'PJ000000000036', fun:this.checkshowByPJID}
                    this.FunctionToken(this.Authority, accountdata)
                }
            },
            checkshowByPJID(value){
                if(value)
                {
                    alert("無權限檢視此頁面，將返回首頁")
                    this.$router.push({ path: '/' })

                }
                else
                {
                    this.changeIframe();
                    if(this.$route.params.id == "animal_1"){
                        this.resizeIframe();
                    }
                    else{
                        var Height = window.innerHeight - document.getElementsByClassName('navbar')[0].offsetHeight - document.getElementsByClassName('breadcrumb')[0].offsetHeight - 32;
                        document.getElementById('u83_input').style.height = Height + 'px';
                    }
                }
            },
            resizeIframe(){
                var Height = document.getElementById('u83_input').offsetWidth * 0.5286;
                document.getElementById('u83_input').style.height = Height + 'px';
            },
            changeIframe: function(){
                    this.breadcrumbItems = [{
                        text: '首頁',
                        to: '/'
                    },
                    {
                        text: '農業儀表板',
                        active: true
                    },
                    {
                        text: this.iframeName[this.$route.params.id],
                        active: true
                    }
                ];
                this.iframeUrl = this.iframeList[this.$route.params.id];
            }
        },
    }
</script>